// extracted by mini-css-extract-plugin
module.exports = {"contenerImage":"settings_contenerImage__M7f-T","logo":"settings_logo__3mlic"};